const CountersSkeleton = () => {
  return (
    <div className="counters-container">
      <div className="counters-grid">
        {[1, 2, 3, 4].map((i) => (
          <div className="counter-card-wrapper" key={i}>
            <div className="card counter">
              {/* Year badge skeleton */}
              <div className="placeholder-glow" style={{ 
                position: 'absolute', 
                top: '10px', 
                right: '10px' 
              }}>
                <span className="placeholder rounded-pill" style={{ 
                  width: '80px', 
                  height: '20px' 
                }}></span>
              </div>

              <div className="counter-card-body">
                {/* Icon skeleton */}
                <div className="counter-card-icon mb-3">
                  <div className="placeholder-glow">
                    <div className="placeholder rounded-circle bg-secondary-subtle" 
                         style={{ width: '60px', height: '60px' }}>
                    </div>
                  </div>
                </div>

                {/* Title skeleton */}
                <div className="placeholder-glow w-100 mb-3">
                  <span className="placeholder col-10 mx-auto rounded" 
                        style={{ height: '18px' }}>
                  </span>
                  <span className="placeholder col-8 mx-auto rounded mt-1" 
                        style={{ height: '16px' }}>
                  </span>
                </div>

                {/* Amount skeleton */}
                <div className="counter-card-amount-container">
                  <div className="placeholder-glow">
                    <span className="placeholder rounded-pill" 
                          style={{ 
                            width: '120px', 
                            height: '32px',
                            background: 'linear-gradient(135deg, #e2e8f0, #cbd5e1)'
                          }}>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .counters-container {
          padding: 0.5rem 0;
          animation: fadeIn 0.5s ease-out;
        }

        .counters-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
        }

        .card.counter {
          background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
          border: 1px solid #e9ecef;
          border-radius: 16px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          padding: 1.5rem 1rem;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .counter-card-body {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.75rem;
        }

        .counter-card-amount-container {
          margin-top: 0.5rem;
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .counters-grid {
            grid-template-columns: 1fr 1fr;
            gap: 1rem;
          }
        }

        @media (max-width: 480px) {
          .counters-grid { grid-template-columns: 1fr; }
        }
      `}</style>
    </div>
  );
};

export default CountersSkeleton;